// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimHistoryCriteriaFooter from './criteria-footer';
import ClaimHistoryInputCriteria from './input-criteria';
import Criteria from '../../state/criteria';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';

const ClaimHistoryReportCriteria = props =>
    <div className='claim-history-report-criteria'>
        <div className='claim-history-criteria'>
            <ClaimHistoryInputCriteria
                allowedDealers={props.selectedAccounts}
                claimTypes={props.claimTypes}
                criteria={props.criteria}
                handleClaimTypeSelect={props.handleClaimTypeSelect}
                handleCreditMemoDateSelect={props.handleCreditMemoDateSelect}
                handleDealerLocationChange={props.handleDealerSelect}
                handleFirstWorkOrderInput={props.handleFirstWorkOrderInput}
                handlePinInputChange={props.handlePinInputChange}
                handleSecondWorkOrderInput={props.handleSecondWorkOrderInput}
            />
        </div>
        <ClaimHistoryCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            handleCriteriaReset={props.handleCriteriaReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateClaimHistoryReport}
        />
    </div>;

ClaimHistoryReportCriteria.displayName = 'ClaimHistoryReportCriteria';
ClaimHistoryReportCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    claimTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair).isRequired),
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    handleClaimTypeSelect: PropTypes.func.isRequired,
    handleCreditMemoDateSelect: PropTypes.func.isRequired,
    handleCriteriaReset: PropTypes.func.isRequired,
    handleDealerSelect: PropTypes.func.isRequired,
    handleFirstWorkOrderInput: PropTypes.func.isRequired,
    handlePinInputChange: PropTypes.func.isRequired,
    handleSecondWorkOrderInput: PropTypes.func.isRequired,
    onCreateClaimHistoryReport: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default ClaimHistoryReportCriteria;



// WEBPACK FOOTER //
// ./src/reports/claim-history/components/claim-history-report-criteria/index.js